import { Row } from "react-bootstrap";
import FooterView from "../FooterView";
import LogoSection from "../LogoSection";

function VenuesView() {
  return (
    <Row>
      <LogoSection />
      <FooterView />
    </Row>
  );
}

export default VenuesView;
